import React, { Component } from 'react';

import Odd from './Odd';
import BookOddsDropdown from './BookOddsDropdown';

class OddsDropdown extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      hover: false
    };

    this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this);
    this.one = this.one.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this);
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  onMouseEnterHandler(e) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.one(e.currentTarget, 'mouseleave', (e) => {
      this.onMouseLeaveHandler();
    });

  }

  // We use a function to capture the event so we can emulate the jquery one() fn
  one(element,eventType,callback,self) {
    var one = function(event) {
        try{
            callback.call(self,event);
        } finally {
            element.removeEventListener(eventType,one);
        }
    }
    element.addEventListener(eventType,one);
  }

  onMouseLeaveHandler() {
    this.timeout = setTimeout(function() {
      this.props.onCloseOdds();
      this.timeout = null
    }.bind(this), 1000);

  }

  render() {
    const { game, score, odds, droppingOdds } = this.props;

    const board_letters = [];
    const board_source = game.notIdle ? (score.goal1 + ':' + score.goal2) : game.time;

    for (var x = 0; x < board_source.length; x++)
    {
        var c = board_source.charAt(x);
        board_letters.push(<span key={x}>{c}</span>);
    }

    var preview_link = !this.props.isExternal && this.props.preview && (<a href={'https://www.betarades.gr/' + this.props.preview.slug} target="_blank" className="oddsDropdown_preview-link"><span>ΑΝΑΛΥΣΗ ΑΓΩΝΑ</span></a>);

    return(
      <div className="oddsDropdown" onMouseEnter={this.onMouseEnterHandler}>

        {/*HEADER*/}
        <div className="header">

          <div>

            <div className="comp">
              {game.isLive &&
                <span>LIVE</span>}
              {game.league_name}
            </div>

            {this.props.teams.hometeam.name}
            <div className={game.isLive ? 'live board' : (game.isFinished ? 'board' : 'time board')}>
              {board_letters}
            </div>
            {this.props.teams.awayteam.name}

            {game.isLive && !game.isHT &&
              <div className="min">( στο <span>{this.props.minute}</span> )</div>}

            {game.isHT &&
              <div className="min">( στο ημίχρονο )</div>}

          </div>

          <span>ΑΠΟΔΟΣΕΙΣ ΠΑΜΕ ΣΤΟΙΧΗΜΑ</span>

          {preview_link}

          <i className="fa fa-times" onClick={this.props.onCloseOdds}></i>
        </div>

        {/*OPAP TABLE*/}
        <table>
          <thead>
            <tr>
              <th colSpan="3" className="divider">
                ΤΕΛΙΚΟ<br />ΑΠΟΤΕΛΕΣΜΑ
              </th>
              <th colSpan="2" className="divider">
                UNDER / OVER <br /> 2.5 GOALS
              </th>
              <th colSpan="3" className="divider">
                ΑΠΟΤΕΛΕΣΜΑ<br/>ΗΜΙΧΡΟΝΟΥ
              </th>
              <th colSpan="3" className="divider">
                ΔΙΠΛΗ ΕΥΚΑΙΡΙΑ
              </th>
              <th colSpan="4">
                ΣΥΝΟΛΟ<br/>ΤΕΡΜΑΤΩΝ
              </th>
            </tr>
            <tr>
              {/*tel*/}
              <th className="em">1</th>
              <th className="em">Χ</th>
              <th className="em divider">2</th>
              {/*ht*/}
              <th className="em">U</th>
              <th className="em divider">O</th>
              {/*HT*/}
              <th className="em">1</th>
              <th className="em">Χ</th>
              <th className="em divider">2</th>
              {/*DOUBLE CHANGE*/}
              <th className="em">1ήΧ</th>
              <th className="em">1ή2</th>
              <th className="em divider">Χή2</th>
              {/*GOALS*/}
              <th className="em">0-1</th>
              <th className="em">2-3</th>
              <th className="em">4-6</th>
              <th className="em">7+</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {/*tel*/}
              <td>
                <Odd odd={{ c: odds.odd_1, p: droppingOdds.odd_1 }} />
              </td>
              <td>
                <Odd odd={{ c: odds.odd_X, p: droppingOdds.odd_X }} />
              </td>
              <td className="divider">
                <Odd odd={{ c: odds.odd_2, p: droppingOdds.odd_2 }} />
              </td>
              {/*UO*/}
              <td>
                <Odd odd={{ c: odds.odd_u25, p: droppingOdds.odd_u25 }} />
              </td>
              <td className="divider">
                <Odd odd={{ c: odds.odd_o25, p: droppingOdds.odd_o25 }} />
              </td>
              {/*HT*/}
              <td>
                <Odd odd={{ c: odds.odd_HT1, p: droppingOdds.odd_HT1 }} />
              </td>
              <td>
                <Odd odd={{ c: odds.odd_HTX, p: droppingOdds.odd_HTX }} />
              </td>
              <td className="divider">
                <Odd odd={{ c: odds.odd_HT2, p: droppingOdds.odd_HT2 }} />
              </td>
              {/*double*/}
              <td>
                <Odd odd={{ c: odds.odd_1X, p: droppingOdds.odd_1X }} />
              </td>
              <td>
                <Odd odd={{ c: odds.odd_12, p: droppingOdds.odd_12 }} />
              </td>
              <td className="divider">
                <Odd odd={{ c: odds.odd_X2, p: droppingOdds.odd_X2 }} />
              </td>
              {/*goals*/}
              <td>
                <Odd odd={{ c: odds.odd_G01, p: droppingOdds.odd_G01 }} />
              </td>
              <td>
                <Odd odd={{ c: odds.odd_G23, p: droppingOdds.odd_G23 }} />
              </td>
              <td>
                <Odd odd={{ c: odds.odd_G46, p: droppingOdds.odd_G46 }} />
              </td>
              <td>
                <Odd odd={{ c: odds.odd_G7, p: droppingOdds.odd_G7 }} />
              </td>
            </tr>
          </tbody>
        </table>

        {/*AD*/}
        {/*<div className="AD_textLink_slider">
          <a href="#" className="AD_textLink">Ολα οι αγώνες Champions League παίζουν στη στοιχιμαν, με 0% γκανιότα! Παίξε εδώ</a>
        </div>*/}

      
        <BookOddsDropdown
          date={this.props.bookOdds.date}
          fid={this.props.bookOdds.fid}
        />
     

      </div>
    )
  }
};

export default OddsDropdown;


// WEBPACK FOOTER //
// ./src/Components/OddsDropdown.js